module.exports = __webpack_public_path__ + "static/toggl-track-overview-f9a63c423f9e4cbf69773d0b259d5fee.jpg";